// import scrollToElement from 'scroll-to-element';

export default class BackToTop {

	constructor(element) {
		this.handleWindowScroll = this.handleWindowScroll.bind(this);
		this.element = element;
	}

	init() {
		this.setVisibility();
		window.addEventListener('scroll', this.handleWindowScroll, { passive: true });
	}

	destroy() {
		window.removeEventListener('scroll', this.handleWindowScroll);
	}

	handleWindowScroll() {
		this.setVisibility();
	}

	setVisibility() {
		if (this.element instanceof HTMLElement) {
			if (window.scrollY === 0) {
				this.element.dataset.isVisible = false;
				this.element.tabIndex = -1;
			} else {
				this.element.dataset.isVisible = true;
				this.element.tabIndex = 0;
			}
		}
	}
}
